<template>
  <div id="app">
    <transition name="show-from-left">
      <popover name="helpplanning" :width="240">
        <Help :titleChart="titleChart"> 
            <div slot="content">
               <p> {{ $t("235") }}  </p>
<!--                 <p>Planned Orders (Planning). </p>
                <p>Executed Orders (Closed) </p>
                <p>and Pending Orders (Pending).</p> -->
            </div>     
          </Help>
      </popover>
    </transition>

    <div class="title-charts">{{ $t("236") }} 
      <button class="bt-help" v-popover:helpplanning.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <div id='buttons' class="btn-group btn-group-sm bt-change-chart" role="group" aria-label="Buttons">
      <button type="button" class="btn btn-secondary" @click="changeTypeChartLine()"><small>{{ $t("237") }} </small></button>
      <button type="button" class="btn btn-secondary" @click="changeTypeChartColumn()"><small>{{ $t("238") }}</small></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("236"),
      tableData: [],
      type: 'line',
      chartOptions: {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
          type: 'line',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: this.$t("131"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
                events:{
                    click: this.loadGrid
                },
                cursor: 'pointer'
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px'
                }
            }
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: this.$t("153_1"),
            color: '#E4D354',
            data: []

        }, {
            name: this.$t("153_2"),
            color: '#90ED7D',
            data: []

        }, {
            name: this.$t("153_3"),
            color: '#F45B5B',
            data: []

        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

      },//fim chartOptions
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){

        let evento = event.point.series.name
        let filtro = ''
        if(evento == 'Planejamento'){
            filtro = 'Planning';
        }
        if(evento == 'Fechado'){
            filtro = 'Closed';
        }
        if (evento == 'Pendente'){
            filtro = 'Pending';
        }
        let filter = !filtro ? event.point.series.name : filtro
        /*console.log('evento', evento)
        console.log('filter', filter)*/
        let status = filter;

        //let status = event.point.series.name;
        let date = event.point.category;
        let point_name = event.point.series.name;
        let NAME_CHART = this.$t("350") + ' - ' + point_name.toUpperCase() 

        const ENDPOINT = `v1/mysemeq-ambev/get-reports?plant=${this.filtersOn.planta}&region=${this.filtersOn.region}&status=${status}&year=${date}&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&online=1`

        let grid = {
        totalDados: event.point.y,
        title: status,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
                "rows": '',
                "plant": this.$t("310"),
                "area": this.$t("311"),
                "sector": this.$t("312"),
                "component": this.$t("313"),
                "component_tag": this.$t("314"),
                "component_type_en": this.$t("315"),
                "machine": this.$t("316"),
                "machine_tag": this.$t("317"),
                "technique_en": this.$t("321"),
                "report_number": this.$t("319"), 
                "approved_datetime": this.$t("320"),
                "link": this.$t("323"),
                "link_rci": this.$t("324"),
                "pending_days": this.$t("325"),
                "delay": this.$t("326"),
                "prescription_created_datePtime": this.$t("327"), 
                "week": this.$t("328"),
                "currency": this.$t("329"),
                "downtime": this.$t("330"),
                "sec_damage": this.$t("331"),
                "work_avoided": this.$t("332"),
            },
            show: true,
            titleHelp: 'Grid - ' + this.$t("350"),
            txtHelp: this.$t("351") 
        }

        if (this.filtersOn.plant) {
            grid.title += ' - ' + this.filtersOn.plant_name
            delete grid.columns['plant']
        } else if (this.filtersOn.region){
            grid.title += ' - ' + this.filtersOn.region
        }

        // console.log(grid);
      
        this.changeGrid(grid);

    },

    getData(){

 
        if(this.filtersOn.area || this.filtersOn.sector || this.filtersOn.machine || this.filtersOn.component ){
            const API = process.env.ROOT_API;
            const ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart-filter' 

            let self = this;

            this.$refs.chart.chart.showLoading();

            let filters = {
                'plant': this.filtersOn.planta,
                'year': this.filtersOn.year,
                'period': this.filtersOn.period,
                'region': this.filtersOn.region,
                'area': this.filtersOn.area_f,
                'sector': this.filtersOn.sector_f,
                'machine': this.filtersOn.machine,
                'component': this.filtersOn.subset,
                'online': 1,
            }

            axios({method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(resp => {
            self.tableData = resp.data;     
            self.$refs.chart.chart.hideLoading();
            })
            .catch(err => {
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
            self.$refs.chart.chart.showLoading('Error');
            })
        }
        else{

            const API = process.env.ROOT_API;
            const ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart'
            let self = this;

            this.$refs.chart.chart.showLoading();

            let filters = {
                'plant': this.filtersOn.planta,
                'year': this.filtersOn.year,
                'period': this.filtersOn.period,
                'region': this.filtersOn.region,
                'area': this.filtersOn.area_f,
                'sector': this.filtersOn.sector_f,
                'machine': this.filtersOn.machine,
                'component': this.filtersOn.subset,
                'online': 1,
            }

            axios({method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(resp => {
            self.tableData = resp.data;     
            self.$refs.chart.chart.hideLoading();
            })
            .catch(err => {
            // from mixin
            self.ApiErrorHandler(self, error.response.data.status_code);
            self.$refs.chart.chart.showLoading('Error');
            })
        }

    },
    setChartData () {
        var self = this
        var res = self.tableData

        self.chartOptions.xAxis.categories = []
        self.chartOptions.series[0].data = []
        self.chartOptions.series[1].data = []
        self.chartOptions.series[2].data = []
        if(res) {
            res.forEach(function (it) {
                self.chartOptions.xAxis.categories.push(it.ref_date)
                self.chartOptions.series[0].data.push(it.new)
                self.chartOptions.series[1].data.push(it.feedback)
                self.chartOptions.series[2].data.push(it.pending)
            })
        }


    },
    changeTypeChartLine () {
        var self = this
        self.chartOptions.chart.type = 'line'
    },
    changeTypeChartColumn () {
        var self = this
        self.chartOptions.chart.type = 'column'
    }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
        this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 14px;*/
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

.bt-change-chart{
    top: -5px!important;
}

div[data-popover="helpplanning"] {
  left: 57% !important;
 top: 4% !important;
}

.title-charts {
    margin-top: 30px;
    margin-bottom: -5px;
}

@media screen and (max-width: 650px) {
    .bt-change-chart {
        top: -42px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/chartsReport.vue